import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Tooltip } from '@material-ui/core'
import PropTypes from 'prop-types'

import './tooltip.component.scss'

const styles = {}

/**
 * NavTooltip Component
 */
class NavTooltip extends Component {
  /**
   * Render
   * @return {XML}
   */
  render () {
    const { title, children } = this.props

    return (
      <Tooltip
        classes={{
          popper: 'nav-tooltip',
          tooltip: 'nav-tooltip_item'
        }}
        title={title}
        placement='right'>
        {children}
      </Tooltip>
    )
  };
}

NavTooltip.propTypes = {
  title: PropTypes.string,
  new: PropTypes.bool
}

NavTooltip.defaultProps = {
  new: false
}

export default withStyles(styles)(NavTooltip)
